import React, { Fragment } from 'react';
import { Modal } from '../../containers';

const GuestModal = () => (
  <Modal
    buttonText="Ok"
    heading="Sorry"
    description={(
      <Fragment>
        This can only be done by our customer service. Please email us to{' '}
        <a href="mailto:help@dayaxe.com" target="_blank" rel="noopener noreferrer">
          help@dayaxe.com
        </a>{' '}
        or request a chat.
      </Fragment>
    )}
  />
);

export default GuestModal;
